import { render, staticRenderFns } from "./NotifyList.vue?vue&type=template&id=7d3c467b"
import script from "./NotifyList.vue?vue&type=script&lang=js"
export * from "./NotifyList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/componenterpserver/gitrepo/unitmodeler/jp-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7d3c467b')) {
      api.createRecord('7d3c467b', component.options)
    } else {
      api.reload('7d3c467b', component.options)
    }
    module.hot.accept("./NotifyList.vue?vue&type=template&id=7d3c467b", function () {
      api.rerender('7d3c467b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/notify/NotifyList.vue"
export default component.exports